import React from 'react';

const ArrowUp = (props) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M13.5 22.5V5.3l8 9.2c.3.3.6.4 1 .5.4 0 .8-.1 1.1-.4.3-.3.4-.7.4-1.1 0-.3-.1-.6-.2-.8L13.2.7c-.1-.1-.2-.2-.3-.2l-.1-.1c-.2-.1-.4-.2-.7-.2-.2 0-.4 0-.6.1-.1 0-.2.1-.3.2-.2 0-.2.1-.3.2L.5 12.5c-.2.2-.4.6-.4.9 0 .4.2.8.5 1.1.5.5 1.4.5 2-.1l8-9.1v17.2c0 .8.6 1.4 1.4 1.4.9 0 1.5-.6 1.5-1.4z" />
  </svg>
);

export default ArrowUp;
